import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CloudExtractLoadService } from '../cloud-extract-load.service';

@Component({
  selector: 'app-extract-from-cloud',
  templateUrl: './extract-from-cloud.component.html',
  styleUrls: ['./extract-from-cloud.component.scss']
})
export class ExtractFromCloudComponent implements OnInit {

  options: any;
  title: string;
  selectTab: string ;
  // submitTab: boolean = true;
  // loadTab: boolean = true;
  constructor(private celService : CloudExtractLoadService,
    private router: Router,private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.options = this.celService.options;
    if(this.options == null){
      this.celService.tabval.subscribe(res => {
        this.selectTab = res;
        if(res === 'select'){
            this.title = 'Extract New Batch from Cloud';
            this.router.navigate(['select'],{ relativeTo: this.route });
        }else if(res === 'submit'){
          this.title = 'Submit Batch ';
          this.router.navigate(['submit'],{ relativeTo: this.route });
        }else if(res === 'load'){
          this.title = 'Extract Batch from Cloud';
          this.router.navigate(['load'],{ relativeTo: this.route });
        }
      });
    }else{
    this.setTitle(this.options.status);
    this.celService.tabval.subscribe(res => {
      this.selectTab = res;
      if(res === 'select'){
        this.title = 'Extract New Batch from Cloud ';
      }else if(res === 'submit'){
        this.title = 'Submit Batch ';
      }else if(res === 'extract'){
        this.title = 'Extract Batch from Cloud';
      }
    });
  }
  }

  setTitle(status){
    switch (status) {
      case 'Transformed':
        this.celService.tabval.next('load');
        this.router.navigate(['load'],{ relativeTo: this.route });
        break;
        case 'New':
        this.celService.tabval.next('select');
        this.router.navigate(['select'],{ relativeTo: this.route });
        break;
        default:this.title = '';
        break;
    }
  }





}
